import settings from "@/api/weather-settings";

export default {
    state: {},
    mutations: {},
    actions: {
        async retrieveWeatherSettings(context, id) {
            try {
                let params = {
                    management_id: await context.dispatch("showManagementID"),
                    setting_id: id,
                }
                const response = await settings.index(params);
                return response.data;
            } catch (error) {
                console.log(error);
            }
        },
        async insertWeatherSettings(context, params) {
            try {
                params.account_id = await context.dispatch("showAccountID");
                params.management_id = await context.dispatch("showManagementID");
                await settings.insert(params);
            } catch (error) {
                console.log(error);
            }
        },
        async updateWeatherSettings(context, params) {
            try {
                params.account_id = await context.dispatch("showAccountID");
                params.management_id = await context.dispatch("showManagementID");
                await settings.update(params);
            } catch (error) {
                console.log(error);
            }
        },
        async deleteWeatherSettings(context, id) {
            try {
                let params = {
                    account_id: await context.dispatch("showAccountID"),
                    management_id: await context.dispatch("showManagementID"),
                    setting_id: id,
                }
                await settings.del(params);
            } catch (error) {
                console.log(error);
            }
        },
    },
    getters: {},
};
